module.exports = __webpack_public_path__ + "static/img/logo9.1571a8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobileImgs/logo9.svg
// module id = 1/Kz
// module chunks = 19